// extracted by mini-css-extract-plugin
module.exports = {"details":"_6Uyret_kyTc9IE4vhDPE2","details__info-panel":"_1sSF_mDNY54SYylTFcN9vz","details__spec-container":"_1l3g16tpO93fhFobXND0E6"};